function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.6673 9.16667C16.4635 7.70018 15.7832 6.34138 14.7312 5.29958C13.6792 4.25778 12.3138 3.59077 10.8454 3.40129C9.37697 3.21182 7.887 3.5104 6.60499 4.25104C5.32297 4.99167 4.32003 6.13328 3.75065 7.5M3.33398 4.16667V7.5H6.66732",
  stroke: "white",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.33398 10.8333C3.53778 12.2998 4.21809 13.6586 5.27012 14.7004C6.32214 15.7422 7.68752 16.4092 9.15593 16.5987C10.6243 16.7882 12.1143 16.4896 13.3963 15.749C14.6783 15.0083 15.6813 13.8667 16.2507 12.5M16.6673 15.8333V12.5H13.334",
  stroke: "white",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgReloadIconDark = function SvgReloadIconDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgReloadIconDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ReloadIcon_Dark.f0446829.svg";
export { ForwardRef as ReactComponent };